// extracted by mini-css-extract-plugin
export default {"section":"section__ECHI97","capitalsIcon":"capitalsIcon__b10L2V"};